export default __webpack_public_path__ + "static/media/open.a4a904ce.svg";